const catalog = [
  {
    id: 'TAIP10-256-2',
    desc: 'TaipanV2 10-256',
    manu: 'AGM',
    price: '$545.00',
  },
  {
    id: 'TAIP15-256-2',
    desc: 'TaipanV2 15-256',
    manu: 'AGM',
    price: '$645.00',
  },
  {
    id: 'TAIP19-320-2',
    desc: 'TaipanV2 19-320',
    manu: 'AGM',
    price: '$745.00',
  },
  {
    id: 'TAIP15-384-2',
    desc: 'TaipanV2 15-384',
    manu: 'AGM',
    price: '$1,095.00',
  },
  {
    id: 'TAIP19-384-2',
    desc: 'TaipanV2 19-384',
    manu: 'AGM',
    price: '$1,395.00',
  },
  {
    id: 'TAIP25-384-2',
    desc: 'TaipanV2 25-384',
    manu: 'AGM',
    price: '$1,695.00',
  },
  {
    id: 'REAC25-384-LRF',
    desc: 'ReachIR LRF 25-384',
    manu: 'AGM',
    price: '$2,195.00',
  },
  {
    id: 'REAC35-640-LRF',
    desc: 'ReachIR LRF 35-640',
    manu: 'AGM',
    price: '$2,695.00',
  },
  {
    id: 'REAC50-640-LRF',
    desc: 'ReachIR LRF 50-640',
    manu: 'AGM',
    price: '$3,294.50',
  },

  {
    id: '314218550203R921',
    desc: 'RattlerV2 19-256',
    manu: 'AGM',
    price: '$895.00',
  },
  {
    id: '314218550204R221',
    desc: 'RattlerV2 25-256',
    manu: 'AGM',
    price: '$1,095.00',
  },
  {
    id: 'RATT25-320-2',
    desc: 'RattlerV2 25-320',
    manu: 'AGM',
    price: '$1,295.00',
  },
  {
    id: '314204550204R231',
    desc: 'RattlerV2 25-384',
    manu: 'AGM',
    price: '$1,695.00',
  },
  {
    id: '314204550205R331',
    desc: 'RattlerV2 35-384',
    manu: 'AGM',
    price: '$1,975.00',
  },
  {
    id: '314205550205R361',
    desc: 'RattlerV2 35-640',
    manu: 'AGM',
    price: '$2,695.00',
  },
  {
    id: '314205550206R561',
    desc: 'RattlerV2 50-640',
    manu: 'AGM',
    price: '$3,295.00',
  },

  {
    id: 'RATT25-384-V3',
    desc: 'RattlerV3 25-384',
    manu: 'AGM',
    price: '$1,995.00',
  },
  {
    id: 'RATT35-384-V3',
    desc: 'RattlerV3 LRF 35-384',
    manu: 'AGM',
    price: '$2,995.00',
  },
  {
    id: 'RATT35-640-V3',
    desc: 'RattlerV3 LRF 35-640',
    manu: 'AGM',
    price: '$4,695.00',
  },
  {
    id: 'RATT50-640-V3',
    desc: 'RattlerV3 LRF 50-640',
    manu: 'AGM',
    price: '$5,295.00',
  },

  {
    id: 'VARM35-384-2',
    desc: 'VarmintV2 LRF 35-384',
    manu: 'AGM',
    price: '$2,195.00',
  },
  {
    id: 'VARM35-640-2',
    desc: 'VarmintV2 LRF 35-640',
    manu: 'AGM',
    price: '$3,295.00',
  },

  {
    id: 'ADDE35-384-2',
    desc: 'AdderV2 35-384',
    manu: 'AGM',
    price: '$2,595.00',
  },
  {
    id: 'ADDE35-384-L2',
    desc: 'AdderV2 LRF 35-384',
    manu: 'AGM',
    price: '$2,995.00',
  },
  {
    id: 'ADDE35-640-2',
    desc: 'AdderV2 LRF 35-640',
    manu: 'AGM',
    price: '$4,695.00',
  },
  {
    id: 'ADDE50-640-2',
    desc: 'AdderV2 LRF 50-640',
    manu: 'AGM',
    price: '$5,495.00',
  },
  {
    id: 'ADDE60-1280-2',
    desc: 'AdderV2 LRF 60-1280',
    manu: 'AGM',
    price: '$7,495.00',
  },

  {
    id: 'CLAR25-384',
    desc: 'Clarion 384 Dual Focus (25/50mm)',
    manu: 'AGM',
    price: '$2,495.00',
  },
  {
    id: 'CLAR35-640',
    desc: 'Clarion 640 Dual Focus (35/60mm)',
    manu: 'AGM',
    price: '$3,795.00',
  },

  {
    id: 'SECU35-384-LRF',
    desc: 'Secutor LRF 35-384',
    manu: 'AGM',
    price: '$2,395.00',
  },
  {
    id: 'SECU50-640-LRF',
    desc: 'Secutor LRF 50-640',
    manu: 'AGM',
    price: '$4,295.00',
  },
  {
    id: 'SECU75-640-LRF',
    desc: 'Secutor LRF 75-640',
    manu: 'AGM',
    price: '$6,895.00',
  },

  {
    id: 'EVOL60-1280-LRF',
    desc: 'Evolver LRF 1280',
    manu: 'AGM',
    price: '$7,495.00',
  },

  {
    id: '314208560103R921',
    desc: 'Rattler-C V2 19-256',
    manu: 'AGM',
    price: '$995.00',
  },
  {
    id: '314205560205R561',
    desc: 'Rattler-C V2 35-384',
    manu: 'AGM',
    price: '$2,195.00',
  },
  {
    id: '314205560206R561',
    desc: 'Rattler-C V2 50-640',
    manu: 'AGM',
    price: '$3,795.00',
  },

  {
    id: 'SECU50-640C-LRF',
    desc: 'Secutor LRF-C 50-640',
    manu: 'AGM',
    price: '$4,295.00',
  },
  {
    id: 'SECU75-640C-LRF',
    desc: 'Secutor LRF-C 75-640',
    manu: 'AGM',
    price: '$6,995.00',
  },

  {
    id: 'OBSE25-256-LRF',
    desc: 'ObservIR LRF 25-256',
    manu: 'AGM',
    price: '$1,595.00',
  },
  {
    id: 'OBSE35-384-LRF',
    desc: 'ObservIR LRF 35-384',
    manu: 'AGM',
    price: '$2,995.00',
  },
  {
    id: 'OBSE35-640-LRF',
    desc: 'ObservIR LRF 35-640',
    manu: 'AGM',
    price: '$4,295.00',
  },
  {
    id: 'OBSE50-640-LRF',
    desc: 'ObservIR LRF 50-640',
    manu: 'AGM',
    price: '$5,995.00',
  },
  {
    id: 'OBSE60-1280-LRF',
    desc: 'ObservIR LRF 60-1280',
    manu: 'AGM',
    price: '$8,495.00',
  },

  { id: 'SPEC50-4K', desc: 'Spectrum LRF 4K', manu: 'AGM', price: '$1,295.00' },
  { id: 'SPEC-4K-M', desc: 'Spectrum 4K Mini', manu: 'AGM', price: '$845.00' },

  {
    id: 'WLAD-CLA1-B1',
    desc: 'WLAD 1B - Weapon Laser Aiming Device, Class 1 in BLACK',
    manu: 'AGM',
    price: '$745.00',
  },
  {
    id: 'WLAD-CLA1-T1',
    desc: 'WLAD 1TAN - Weapon Laser Aiming Device, Class 1 in TAN',
    manu: 'AGM',
    price: '$895.00',
  },
  {
    id: 'WLAD-CLA3-B1',
    desc: 'WLAD 3B - Weapon Laser Aiming Device, Class 3B in BLACK, Military/LE sales Only!',
    manu: 'AGM',
    price: '$1,195.00',
  },
  {
    id: 'WLAD-CLA3-T1',
    desc: 'WLAD 3TAN - Weapon Laser Aiming Device, Class 3B in TAN, Military/LE sales Only!',
    manu: 'AGM',
    price: '$1,295.00',
  },

  { id: '6628XPB31', desc: 'Solar Power Bank', manu: 'AGM', price: '$49.00' },
  {
    id: '6322TT10',
    desc: 'Thermal Targets (single)',
    manu: 'AGM',
    price: '$10.00',
  },
  {
    id: '633125S1',
    desc: 'Pack of 25 Thermal Targets',
    manu: 'AGM',
    price: '$139.00',
  },
  {
    id: '633150S1',
    desc: 'Pack of 50 Thermal Targets',
    manu: 'AGM',
    price: '$279.00',
  },
  {
    id: '11PG41281053111',
    desc: 'PVS14G-AL1 – Night Vision Monocular with Gen 2+ Auto-Gated 64 lp/mm "Level 1", P43-Green Phosphor IIT.',
    manu: 'AGM',
    price: '$2,295.00',
  },
  {
    id: '11PG41281054111',
    desc: 'PVS14G-AW1 – Night Vision Monocular with Gen 2+ Auto-Gated 64 lp/mm "Level 1", P45-White Phosphor IIT.',
    manu: 'AGM',
    price: '$2,495.00',
  },
  {
    id: '11P14122483021',
    desc: 'PVS-14 NL2 – Gen 2+ "Level 2" P43-Green IIT',
    manu: 'AGM',
    price: '$2,695.00',
  },
  {
    id: '11P14122483011',
    desc: 'PVS-14 NL1 – Gen 2+ "Level 1" P43-Green IIT',
    manu: 'AGM',
    price: '$2,995.00',
  },
  {
    id: '11P14122464021',
    desc: 'PVS-14 NW2 – Gen 2+ "Level 2", P45-White IIT',
    manu: 'AGM',
    price: '$2,895.00',
  },
  {
    id: '11P14122464011',
    desc: 'PVS-14 NW1 – Gen 2+ "Level 1", P45-White IIT',
    manu: 'AGM',
    price: '$3,195.00',
  },

  {
    id: '11P14123483121',
    desc: 'PVS-14 3AL2 – Gen 3 Auto-Gated "Level 2", P43-Green IIT, Made in the USA',
    manu: 'AGM',
    price: '$3,795.00',
  },
  {
    id: '11P14123483111',
    desc: 'PVS-14 3AL1 – Gen 3 Auto-Gated "Level 1", P43-Green IIT, Made in the USA',
    manu: 'AGM',
    price: '$3,995.00',
  },
  {
    id: '11P14123484121',
    desc: 'PVS-14 3AW2 – Gen 3 Auto-Gated "Level 2", P45-White IIT, Made in the USA',
    manu: 'AGM',
    price: '$3,995.00',
  },
  {
    id: '11P14123484111',
    desc: 'PVS-14 3AW1 – Gen 3 Auto-Gated "Level 1", P45-White IIT, Made in the USA',
    manu: 'AGM',
    price: '$4,295.00',
  },
  {
    id: '11P4M123474111',
    desc: 'PVS-14 3APW – FOM 2000+ Gen 3 Auto-Gated, P45-White IIT, Made in the USA',
    manu: 'AGM',
    price: '$4,995.00',
  },

  {
    id: '11PE41284153011',
    desc: 'PVS-14E NL1 – Gen 2+ "Level 1" P43-Green IIT',
    manu: 'AGM',
    price: '$3,095.00',
  },
  {
    id: '11PE41284154011',
    desc: 'PVS-14E NW1 – Gen 2+ "Level 1" P45-White IIT',
    manu: 'AGM',
    price: '$3,395.00',
  },
  {
    id: '11PE41284123111',
    desc: 'PVS-14E AP – Photonis ECHO Auto-Gated FOM1600 P43-Green IIT',
    manu: 'AGM',
    price: '$4,195.00',
  },
  {
    id: '11PE41284124111',
    desc: 'PVS-14E APW – Photonis ECHO Auto-Gated FOM1600 P45-White IIT',
    manu: 'AGM',
    price: '$4,395.00',
  },
  {
    id: '11PE412941143111',
    desc: 'PVS-14E 3AL1 – Gen 3 Auto-Gated "Level 1", P43-Green IIT, Made in the USA',
    manu: 'AGM',
    price: '$4,295.00',
  },
  {
    id: '11PE412941144111',
    desc: 'PVS-14E 3AW1 – Gen 3 Auto-Gated "Level 1", P45-White IIT, Made in the USA',
    manu: 'AGM',
    price: '$4,595.00',
  },
  {
    id: '11PE41244194111',
    desc: 'PVS-14E 3APW – FOM 2200+ Gen 3 Auto-Gated, P45-White IIT, Made in the USA',
    manu: 'AGM',
    price: '$4,695.00',
  },

  {
    id: '12W7P122153211',
    desc: 'Wolf-7 Pro NL1 – Gen 2+ "Level 1" P43-Green IIT',
    manu: 'AGM',
    price: '$2,895.00',
  },
  {
    id: '12W7P122154211',
    desc: 'Wolf-7 Pro NW1 – Gen 2+ "Level 1", P45-White IIT',
    manu: 'AGM',
    price: '$3,095.00',
  },

  {
    id: '12PV7122283011',
    desc: 'PVS-7 NL1 – Gen 2+ "Level 1" P43-Green IIT',
    manu: 'AGM',
    price: '$3,095.00',
  },
  {
    id: '12PV7122284011',
    desc: 'PVS-7 NW1 – Gen 2+ "Level 1" P45-White IIT',
    manu: 'AGM',
    price: '$3,295.00',
  },
  {
    id: '12PV7123283111',
    desc: 'PVS-7 3AL1 – Gen 3 Auto-Gated "Level 1" P43-Green IIT, Made in the USA',
    manu: 'AGM',
    price: '$4,095.00',
  },
  {
    id: '12PV7123284111',
    desc: 'PVS-7 3AW1 – Gen 3 Auto-Gated "Level 1" P45-White IIT, Made in the USA',
    manu: 'AGM',
    price: '$4,295.00',
  },

  {
    id: '14NV4122483011',
    desc: 'NVG-40 NL1 – Gen 2+ "Level 1", P43-Green IIT',
    manu: 'AGM',
    price: '$5,295.00',
  },
  {
    id: '14NV4122484011',
    desc: 'NVG-40 NW1 – Gen 2+ "Level 1", P45-White IIT',
    manu: 'AGM',
    price: '$5,795.00',
  },
  {
    id: '14NV4123483111',
    desc: 'NVG-40 3AL1 – Gen 3 Auto-Gated "Level 1", P43-Green IIT, Made in USA',
    manu: 'AGM',
    price: '$6,995.00',
  },
  {
    id: '14NV4123414111',
    desc: 'NVG-40 3AW1 – Gen 3 Auto-Gated "Level 1", P45-White IIT, Made in USA',
    manu: 'AGM',
    price: '$7,895.00',
  },
  {
    id: '14NV4123474111',
    desc: 'NVG-40 3APW – FOM 2000+ Gen 3 Auto-Gated, P45-White IIT, Made in USA',
    manu: 'AGM',
    price: '$8,395.00',
  },

  {
    id: '14NV5122483011',
    desc: 'NVG-50 NL1 – 51° FOV with Gen 2+ "Level 1", P43-Green IIT',
    manu: 'AGM',
    price: '$5,595.00',
  },
  {
    id: '14NV5122484011',
    desc: 'NVG-50 NW1 – 51° FOV with Gen 2+ "Level 1", P45-White IIT',
    manu: 'AGM',
    price: '$6,195.00',
  },
  {
    id: '14NV5123483111',
    desc: 'NVG-50 3AL1 – 51° FOV with Gen 3 Auto-Gated "Level 1", P43-Green IIT, Made in USA',
    manu: 'AGM',
    price: '$8,495.00',
  },
  {
    id: '14NV5123484111',
    desc: 'NVG-50 3AW1 – 51° FOV with Gen 3 Auto-Gated "Level 1", P45-White IIT, Made in USA',
    manu: 'AGM',
    price: '$8,895.00',
  },
  {
    id: '14NV5123474111',
    desc: 'NVG-50 3APW – 51° FOV with FOM 2000+ Gen 3 Auto-Gated, P45-White IIT, Made in USA',
    manu: 'AGM',
    price: '$8,995.00',
  },

  {
    id: '12UN41284153011',
    desc: 'UNVG NL1 – Gen 2+ "Level 1", P43-Green IIT',
    manu: 'AGM',
    price: '$6,295.00',
  },
  {
    id: '12UN41284154011',
    desc: 'UNVG NW1 – Gen 2+ "Level 1", P45-White IIT',
    manu: 'AGM',
    price: '$6,995.00',
  },
  {
    id: '12UN41284123111',
    desc: 'UNVG AP – Gen 2+ Auto-Gated FOM1800 P43-Green IIT',
    manu: 'AGM',
    price: '$7,495.00',
  },
  {
    id: '12UN41284124111',
    desc: 'UNVG APW – Gen 2+ Auto-Gated FOM1800 P45-White IIT',
    manu: 'AGM',
    price: '$7,795.00',
  },
  {
    id: '12UN412941143111',
    desc: 'UNVG 3AL1 – Gen 3 Auto-Gated "Level 1", P43-Green IIT, Made in USA',
    manu: 'AGM',
    price: '$8,995.00',
  },
  {
    id: '12UN412941144111',
    desc: 'UNVG 3AW1 – Gen 3 Auto-Gated "Level 1", P45-White IIT, Made in USA',
    manu: 'AGM',
    price: '$9,795.00',
  },
  {
    id: '12UN41294194111',
    desc: 'UNVG 3APW – FOM 2000+ Gen 3 Auto-Gated, P45-White IIT, Made in USA',
    manu: 'AGM',
    price: '$9,995.00',
  },

  {
    id: '12UN51284153011',
    desc: 'UNVG-51 NL1 – 51° FOV with Gen 2+ "Level 1", P43-Green IIT',
    manu: 'AGM',
    price: '$6,695.00',
  },
  {
    id: '12UN51284154011',
    desc: 'UNVG-51 NW1 – 51° FOV with Gen 2+ "Level 1", P45-Green IIT',
    manu: 'AGM',
    price: '$7,495.00',
  },
  {
    id: '12UN512941143111',
    desc: 'UNVG-51 3AL1 – 51° FOV with Gen 3 Auto-Gated "Level 1", P43-Green IIT, Made in USA',
    manu: 'AGM',
    price: '$9,495.00',
  },
  {
    id: '12UN512941144111',
    desc: 'UNVG-51 3AW1 – 51° FOV with Gen 3 Auto-Gated "Level 1", P45-White IIT, Made in USA',
    manu: 'AGM',
    price: '$9,995.00',
  },
  {
    id: '12UN51294194111',
    desc: 'UNVG-51 3APW – 51° FOV with FOM 2000+ Gen 3 Auto-Gated, P45-White IIT, Made in USA',
    manu: 'AGM',
    price: '$10,295.00',
  },

  {
    id: '12UR412941103111',
    desc: 'UNVG-RPO 3AP – FOM 2000+ Gen 3 Auto-Gated, P43-Green IIT, Made in USA',
    manu: 'AGM',
    price: '$10,195.00',
  },
  {
    id: '12UR412941124111',
    desc: 'UNVG-RPO 3APW – FOM 2000+ Gen 3 Auto-Gated, P45-White IIT, Made in USA',
    manu: 'AGM',
    price: '$10,795.00',
  },
  {
    id: '12UR412941124111',
    desc: 'AGM UNVG 3APWH FOM 2376 Plus Gen 3 Auto Gated, P45-White IIT, Made in USA. 25 inch battery cable, battery pack with integrated IR strobe, qty 2 right angle 4 pin Fischer connectors.',
    manu: 'AGM',
    price: '$14,495.00',
  },
  {
    id: '12UNH41294194111K',
    desc: 'AGM UNVG 3APWH FOM 2376 Plus Gen 3 Auto Gated, P45-White IIT, Made in USA. 25 inch battery cable, battery pack with integrated IR strobe, qty 2 right angle 4 pin Fischer connectors. Includes Wilcox G24 Mount Tan',
    manu: 'AGM',
    price: '$15,038.12',
  },
  {
    id: '28300G24-T',
    desc: 'The Wilcox G24 is a breakaway NVG mount built for Operators running night vision in dynamic environments. Dovetail interface, low-profile design. The breakaway function reduces risk during snags, fast-rope, or confined movement. Fully adjustable with one-handed operation, the G24 keeps your NODs stable, repeatable, and mission-ready. Color Tan.',
    manu: 'WILCOX',
    price: '$543.12',
  },
];

const tableBody = document.querySelector('.table__catalog tbody');

catalog.forEach(item => {
  const row = document.createElement('tr');
  // Create cells for ID, Description, and Price
  const idCell = document.createElement('td');
  idCell.textContent = item.id;

  const descCell = document.createElement('td');
  descCell.textContent = item.desc;

  const manuCell = document.createElement('td');
  manuCell.textContent = item.manu;

  const priceCell = document.createElement('td');
  priceCell.textContent = item.price;

  // Append the cells to the row
  row.appendChild(idCell);
  row.appendChild(descCell);
  row.appendChild(manuCell);
  row.appendChild(priceCell);

  // Append the row to the table body
  tableBody.appendChild(row);
});
